import React, { useState } from "react";
import { createPortal } from "react-dom";
import "../component/modalAddProduct.css";
import { Constant } from "../../../helper/constant";
import { useNavigate } from "react-router-dom";

const ModalAddProduct = ({
  isShowModal,
  onCloseModal,
  onSubmitData,
  productObject,
}) => {
  const navigate = useNavigate();
  const [productData, setProductData] = useState(productObject);
  const closeModal = () => {
    setProductData({
      product_id: "",
      product_name: "",
      product_category: {
        product_category_id: "",
        product_category_name: "",
      },
      product_unit: {
        product_unit_id: "",
        product_unit_name: "",
      },
      product_rack: "",
      product_hjb: "",
      product_hjr: "",
      product_partner_selling_price: "",
      product_total_stock: 0,
    });
    onCloseModal();
  };
  const [listSuggestionCategory, setListSuggestionCategory] = useState([]);
  const [listSuggestionUnit, setListSuggestionUnit] = useState([]);
  const userData = JSON.parse(localStorage.getItem("user_data"));
  console.log(userData);
  const checkCategoryAutoComplete = (keyword) => {
    if (keyword.length > 0) {
      findCategory(keyword);
    } else {
      setListSuggestionCategory([]);
    }
  };

  // =====================
  // Request Method
  // =====================

  const findCategory = async (keyword) => {
    try {
      const response = await fetch(
        Constant.BASE_API_URL +
          "/kategori-produk/autocomplete?keyword=" +
          keyword,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Terdapat Kesalahan Dalam Memproses Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;
      setListSuggestionCategory(data.product_category);
    } catch (error) {
      setListSuggestionCategory([]);
    }
  };

  const checkUnitAutoComplete = (keyword) => {
    if (keyword.length > 0) {
      findUnit(keyword);
    } else {
      setListSuggestionUnit([]);
    }
  };

  // =====================
  // Request Method
  // =====================

  const findUnit = async (keyword) => {
    try {
      const response = await fetch(
        Constant.BASE_API_URL + "/unit-produk/autocomplete?keyword=" + keyword,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Terdapat Kesalahan Dalam Memproses Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;
      setListSuggestionUnit(data.product_unit);
    } catch (error) {
      setListSuggestionUnit([]);
    }
  };

  return createPortal(
    isShowModal && (
      <div className="modal-product-container">
        <div className="modal-product-content">
          <header className="modal-product-header">
            <h2 className="modal-product-header-title">
              {productObject.product_id ? "Edit Produk" : "Tambah Produk"}
            </h2>
            <button className="modal-header-close-button" onClick={closeModal}>
              &times;
            </button>
          </header>
          <main className="modal-product-main">
            <div className="form-group">
              <div className="input_title_label_container">
                <span className="input_title_label"> Produk Baru</span>
              </div>
              <div className="input_product_field_container">
                <input
                  type="text"
                  value={
                    productData.product_name ? productData.product_name : ""
                  }
                  onChange={(e) =>
                    setProductData({
                      ...productData,
                      product_name: e.target.value,
                    })
                  }
                  placeholder="Masukkan produk"
                />
              </div>
              <div className="input-doctor-title-label-container">
                <span className="input-title-label ">Kategori Product</span>
              </div>
              <div className="input_product_field_container">
                <input
                  type="text"
                  value={
                    productData.product_category.product_category_name || ""
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    setProductData((productData) => ({
                      ...productData,
                      product_category: {
                        ...productData.product_category,
                        product_category_name: value,
                      },
                    }));
                    checkCategoryAutoComplete(value);
                  }}
                  placeholder="Masukkan nama kategori"
                />
              </div>
              {listSuggestionCategory.length > 0 && (
                <ul className="dropdown-list">
                  {listSuggestionCategory.map((category) => (
                    <li key={category.product_category_id}>
                      <button
                        className="dropdown-button"
                        onClick={() => {
                          setProductData((productData) => ({
                            ...productData,
                            product_category: {
                              product_category_name:
                                category.product_category_name,
                              product_category_id: category.product_category_id,
                            },
                          }));
                          setListSuggestionCategory([]);
                        }}
                      >
                        {category.product_category_name}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
              <div className="input-doctor-title-label-container">
                <span className="input-title-label ">Unit Product</span>
              </div>
              <div className="input_product_field_container">
                <input
                  type="text"
                  value={productData.product_unit.product_unit_name || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setProductData((productData) => ({
                      ...productData,
                      product_unit: {
                        ...productData.product_unit,
                        product_unit_name: value,
                      },
                    }));
                    checkUnitAutoComplete(value);
                  }}
                  placeholder="Masukkan nama unit"
                />
              </div>
              {listSuggestionUnit.length > 0 && (
                <ul className="dropdown-list">
                  {listSuggestionUnit.map((unit) => (
                    <li key={unit.product_unit_id}>
                      <button
                        className="dropdown-button"
                        onClick={() => {
                          setProductData((productData) => ({
                            ...productData,
                            product_unit: {
                              product_unit_name: unit.product_unit_name,
                              product_unit_id: unit.product_unit_id,
                            },
                          }));
                          setListSuggestionUnit([]);
                        }}
                      >
                        {unit.product_unit_name}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
              <div className="input_title_label_container">
                <span className="input_title_label"> Rak Product</span>
              </div>
              <div className="input_product_field_container">
                <input
                  type="text"
                  value={
                    productData.product_rack ? productData.product_rack : ""
                  }
                  onChange={(e) =>
                    setProductData({
                      ...productData,
                      product_rack: e.target.value,
                    })
                  }
                  placeholder="Masukkan Posisi Rak produk"
                />
              </div>
              {productData.product_id === "" && (
                <div>
                  <div className="input_title_label_container">
                    <span className="input_title_label"> HJB Produk</span>
                  </div>
                  <div className="input_product_field_container">
                    <input
                      type="text"
                      value={
                        productData.product_hjb ? productData.product_hjb : ""
                      }
                      onChange={(e) =>
                        setProductData({
                          ...productData,
                          product_hjb: e.target.value,
                        })
                      }
                      placeholder="Masukkan HJB Produk"
                    />
                  </div>
                  <div className="input_title_label_container">
                    <span className="input_title_label"> HJR Produk</span>
                  </div>
                  <div className="input_product_field_container">
                    <input
                      type="text"
                      value={
                        productData.product_hjr ? productData.product_hjr : ""
                      }
                      onChange={(e) =>
                        setProductData({
                          ...productData,
                          product_hjr: e.target.value,
                        })
                      }
                      placeholder="Masukkan HJR Produk"
                    />
                  </div>
                  <div className="input_title_label_container">
                    <span className="input_title_label">
                      {" "}
                      Harga Rekanan Produk
                    </span>
                  </div>
                  <div className="input_product_field_container">
                    <input
                      type="text"
                      value={
                        productData.product_partner_selling_price
                          ? productData.product_partner_selling_price
                          : ""
                      }
                      onChange={(e) =>
                        setProductData({
                          ...productData,
                          product_partner_selling_price: e.target.value,
                        })
                      }
                      placeholder="Masukkan Harga Jual Rekanan Produk"
                    />
                  </div>
                </div>
              )}

              {productData.product_id !== "" && (
                <div>
                  <div className="input_title_label_container">
                    <span className="input_title_label"> HJB Produk</span>
                  </div>
                  <div className="input_product_field_container">
                    <input
                      type="text"
                      value={
                        productData.product_hjb ? productData.product_hjb : ""
                      }
                      onChange={(e) =>
                        setProductData({
                          ...productData,
                          product_hjb: e.target.value,
                        })
                      }
                      placeholder="Masukkan HJB Produk"
                      disabled={
                        userData.staff_system_role !== "ADMIN" &&
                        userData.staff_system_role !== "MANAGER"
                      }
                    />
                  </div>
                  <div className="input_title_label_container">
                    <span className="input_title_label"> HJR Produk</span>
                  </div>
                  <div className="input_product_field_container">
                    <input
                      type="text"
                      value={
                        productData.product_hjr ? productData.product_hjr : ""
                      }
                      onChange={(e) =>
                        setProductData({
                          ...productData,
                          product_hjr: e.target.value,
                        })
                      }
                      placeholder="Masukkan HJR Produk"
                      disabled={
                        userData.staff_system_role !== "ADMIN" &&
                        userData.staff_system_role !== "MANAGER"
                      }
                    />
                  </div>
                  <div className="input_title_label_container">
                    <span className="input_title_label">
                      Harga Rekanan Produk
                    </span>
                  </div>
                  <div className="input_product_field_container">
                    <input
                      type="text"
                      value={
                        productData.product_partner_selling_price
                          ? productData.product_partner_selling_price
                          : ""
                      }
                      onChange={(e) =>
                        setProductData({
                          ...productData,
                          product_partner_selling_price: e.target.value,
                        })
                      }
                      placeholder="Masukkan Harga Jual Rekanan Produk"
                      disabled={
                        userData.staff_system_role !== "ADMIN" &&
                        userData.staff_system_role !== "MANAGER"
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          </main>
          <footer className="modal-product-footer">
            <button className="modal-close-button" onClick={closeModal}>
              Batal
            </button>
            <button
              className="modal-submit-button"
              onClick={() => {
                const isEditData = productObject.product_id !== "";
                onSubmitData(productData, isEditData);
                setProductData({
                  product_id: "",
                  product_category_id: "",
                  product_unit_id: "",
                  product_name: "",
                  product_rack: "",
                  product_hjb: "",
                  product_hjr: "",
                  product_partner_selling_price: "",
                  product_total_stock: 0,
                });
              }}
            >
              Submit
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalAddProduct;
